function EJlock(on) {
  var b = document.body;
  if (on) { var sb = window.innerWidth - document.documentElement.clientWidth; b.style.overflow = 'hidden'; if (sb > 0) b.style.marginRight = sb + 'px'; }
  else { b.style.overflow = ''; b.style.marginRight = ''; }
}
/* Essentially Jo theme script. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var doc = document.documentElement;
  doc.classList.add('js');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EJ = window.EJ || {};
  window.dataLayer = window.dataLayer || [];

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function onScroll(fn) { var ticking = false; window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { fn(); ticking = false; }); } }, { passive: true }); fn(); }

  /* ---------- Analytics (GA4 after consent) ---------- */
  var gaLoaded = false;
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = window.gtag || gtag;
  function loadGA() {
    if (gaLoaded || !EJ.ga4Id) return;
    gaLoaded = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(EJ.ga4Id);
    document.head.appendChild(s);
    window.gtag('js', new Date());
    window.gtag('config', EJ.ga4Id);
  }
  function track(name, params) {
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
    if (gaLoaded) window.gtag('event', name, params || {});
  }
  window.EJtrack = track;

  /* ---------- Cookie consent (Shopify Customer Privacy API) ---------- */
  var CONSENT_KEY = 'ej_cookie_consent';
  function storedChoice() { try { return localStorage.getItem(CONSENT_KEY); } catch (e) { return null; } }
  function storeChoice(v) { try { localStorage.setItem(CONSENT_KEY, v); } catch (e) {} }
  function withPrivacy(cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) return cb(window.Shopify.customerPrivacy);
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) return cb(null);
        cb(window.Shopify.customerPrivacy || null);
      });
    } else { cb(null); }
  }
  function initConsent() {
    var banner = $('[data-cookie-banner]');
    withPrivacy(function (cp) {
      var choice = storedChoice();
      var allowed = cp && cp.analyticsProcessingAllowed ? cp.analyticsProcessingAllowed() : choice === 'accepted';
      var current = cp && cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
      var undecided = !choice && (!current || !current.analytics);
      if (choice === 'accepted' || (allowed && current && current.analytics === 'yes')) loadGA();
      if (!banner) return;
      if (undecided) setTimeout(function () { banner.hidden = false; }, 1500);
      function decide(accepted) {
        storeChoice(accepted ? 'accepted' : 'declined');
        banner.hidden = true;
        if (cp && cp.setTrackingConsent) {
          cp.setTrackingConsent({ analytics: accepted, marketing: accepted, preferences: accepted, sale_of_data: accepted }, function () {});
        }
        if (accepted) loadGA();
      }
      $('[data-cookie-accept]', banner).addEventListener('click', function () { decide(true); });
      $('[data-cookie-decline]', banner).addEventListener('click', function () { decide(false); });
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    onScroll(function () { header.classList.toggle('is-scrolled', window.scrollY > 80); });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var panel = $('[data-menu-panel]');
    var openBtn = $('[data-menu-open]');
    if (!panel || !openBtn) return;
    var lastFocus = null;
    function focusables() { return $$('a[href], button:not([disabled])', panel); }
    function open() {
      lastFocus = document.activeElement;
      EJlock(true); document.body.classList.add('menu-open');
      openBtn.setAttribute('aria-expanded', 'true');
      var f = focusables(); if (f.length) setTimeout(function () { f[0].focus(); }, 50);
    }
    function close() {
      document.body.classList.remove('menu-open'); EJlock(false);
      openBtn.setAttribute('aria-expanded', 'false');
      if (lastFocus) lastFocus.focus();
    }
    openBtn.addEventListener('click', open);
    $$('[data-menu-close]').forEach(function (el) { el.addEventListener('click', close); });
    $$('a', panel).forEach(function (a) { a.addEventListener('click', function () { document.body.classList.remove('menu-open'); EJlock(false); }); });
    document.addEventListener('keydown', function (e) {
      if (!document.body.classList.contains('menu-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.addEventListener('resize', function () { if (window.innerWidth >= 1024 && document.body.classList.contains('menu-open')) close(); });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = $$('.animate-on-scroll');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('visible'); io.unobserve(entry.target); } });
    }, { threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Hero parallax (home) ---------- */
  function initParallax() {
    var layer = $('[data-parallax]');
    if (!layer || reduceMotion) return;
    onScroll(function () { var y = window.scrollY; if (y < window.innerHeight * 1.5) layer.style.transform = 'translateY(' + (y * 0.4) + 'px)'; });
  }

  /* ---------- Image fade-in on load ---------- */
  function initImageFade() {
    $$('[data-fade-img]').forEach(function (img) {
      function done() { img.classList.add('is-loaded'); var ph = img.parentNode.querySelector('[data-fade-placeholder]'); if (ph) ph.classList.add('is-hidden'); }
      if (img.complete && img.naturalWidth > 0) done(); else { img.addEventListener('load', done); img.addEventListener('error', done); }
    });
  }

  /* ---------- Back to top ---------- */
  function initBackToTop() {
    var btn = $('[data-back-to-top]');
    if (!btn) return;
    onScroll(function () { btn.hidden = window.scrollY <= 400; });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
  }

  /* ---------- Smooth scroll links ---------- */
  function initSmoothScroll() {
    $$('[data-scroll-to]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = document.getElementById(btn.getAttribute('data-scroll-to'));
        if (t) t.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- Accordions (FAQ, What's inside) ---------- */
  function initAccordions() {
    $$('[data-accordion]').forEach(function (group) {
      var single = group.hasAttribute('data-accordion-single');
      $$('[data-accordion-trigger]', group).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          var open = btn.getAttribute('aria-expanded') === 'true';
          if (single) {
            $$('[data-accordion-trigger]', group).forEach(function (b) {
              b.setAttribute('aria-expanded', 'false');
              var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = true;
            });
          }
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (panel) panel.hidden = open;
        });
      });
    });
  }

  /* ---------- Affiliate click tracking ---------- */
  function initAffiliate() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-affiliate]');
      if (!a) return;
      track('affiliate_click', { brand_name: a.getAttribute('data-brand') || '', product_name: a.getAttribute('data-product') || '' });
    });
  }

  /* ---------- Newsletter ---------- */
  function initNewsletter() {
    $$('form').filter(function (f) { return f.querySelector('input[name="contact[tags]"][value="newsletter"]'); }).forEach(function (form) {
      form.addEventListener('submit', function () { track('newsletter_signup', { source: window.location.pathname }); });
    });
  }

  /* ---------- Toast ---------- */
  function toast(title, desc) {
    var t = document.createElement('div');
    t.className = 'toast'; t.setAttribute('role', 'status');
    t.innerHTML = '<strong></strong><span></span>';
    t.querySelector('strong').textContent = title;
    t.querySelector('span').textContent = desc || '';
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4000);
  }
  window.EJtoast = toast;

  /* ---------- Cart drawer (Ajax Cart API) ---------- */
  var Cart = {
    drawer: null,
    fmt: function (cents, currency) {
      try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(cents / 100); }
      catch (e) { return (currency || 'GBP') + ' ' + (cents / 100).toFixed(2); }
    },
    render: function (cart) {
      var d = this.drawer; if (!d) return;
      var count = cart.item_count || 0;
      $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
      $('[data-cart-desc]', d).textContent = count === 0 ? 'Your cart is empty' : count + ' item' + (count !== 1 ? 's' : '') + ' in your cart';
      var body = $('[data-cart-body]', d);
      var foot = $('[data-cart-foot]', d);
      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<div class="cart-drawer__empty"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg><p class="body-text">Your cart is empty</p></div>';
        foot.hidden = true; return;
      }
      var self = this;
      body.innerHTML = '';
      var list = document.createElement('div'); list.style.display = 'grid'; list.style.gap = '1rem';
      cart.items.forEach(function (item, i) {
        var row = document.createElement('div'); row.className = 'cart-line';
        var img = item.image ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=128" alt="" width="64" height="64" loading="lazy">' : '';
        var opts = (item.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return o.value; }).join(' · ');
        row.innerHTML =
          '<div class="cart-line__img">' + img + '</div>' +
          '<div class="cart-line__info"><h3 class="cart-line__title"></h3><p class="cart-line__meta"></p><p class="cart-line__price">' + self.fmt(item.final_line_price, cart.currency) + '</p></div>' +
          '<div class="cart-line__controls">' +
            '<button type="button" class="cart-line__remove" aria-label="Remove" data-line="' + (i + 1) + '" data-qty="0"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/></svg></button>' +
            '<div class="qty"><button type="button" aria-label="Decrease quantity" data-line="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '">&minus;</button><span>' + item.quantity + '</span><button type="button" aria-label="Increase quantity" data-line="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '">+</button></div>' +
          '</div>';
        row.querySelector('.cart-line__title').textContent = item.product_title;
        row.querySelector('.cart-line__meta').textContent = opts;
        list.appendChild(row);
      });
      body.appendChild(list);
      $('[data-cart-total]', d).textContent = self.fmt(cart.total_price, cart.currency);
      foot.hidden = false;
    },
    fetch: function () { var s = this; return fetch(EJ.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { s.render(c); return c; }); },
    change: function (line, qty) {
      var s = this;
      return fetch(EJ.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function (c) { s.render(c); return c; });
    },
    add: function (variantId, qty, properties) {
      var s = this;
      var item = { id: variantId, quantity: qty || 1 };
      if (properties) item.properties = properties;
      return fetch(EJ.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return s.fetch(); });
    },
    open: function () {
      var d = this.drawer; if (!d) return;
      this.lastFocus = document.activeElement;
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); EJlock(true);
      this.fetch();
      setTimeout(function () { var c = $('.cart-drawer__close', d); if (c) c.focus(); }, 50);
    },
    close: function () {
      var d = this.drawer; if (!d) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); EJlock(false);
      if (this.lastFocus) this.lastFocus.focus();
    },
    init: function () {
      var s = this;
      s.drawer = $('[data-cart-drawer]');
      if (!s.drawer) return;
      try { s.render(JSON.parse($('#CartData').textContent)); } catch (e) {}
      $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); s.open(); }); });
      $$('[data-cart-close]', s.drawer).forEach(function (b) { b.addEventListener('click', function () { s.close(); }); });
      s.drawer.addEventListener('click', function (e) {
        var b = e.target.closest('[data-line]'); if (!b) return;
        s.change(parseInt(b.getAttribute('data-line'), 10), Math.max(0, parseInt(b.getAttribute('data-qty'), 10)));
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && s.drawer.classList.contains('is-open')) s.close(); });
    }
  };
  window.EJcart = Cart;

  /* ---------- Add to cart buttons ---------- */
  function initAddButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      var variant = btn.getAttribute('data-variant-id');
      var checkout = btn.hasAttribute('data-checkout');
      var props = null;
      var scope = btn.closest('[data-gift-scope]');
      if (scope) {
        var toggle = $('[data-gift-toggle]', scope);
        if (toggle && toggle.getAttribute('aria-checked') === 'true') {
          props = { 'Send as gift': 'Yes' };
          var msg = $('[data-gift-message]', scope); var addr = $('[data-gift-address]', scope);
          if (msg && msg.value.trim()) props['Gift message'] = msg.value.trim();
          if (addr && addr.value.trim()) props['Recipient address'] = addr.value.trim();
        }
      }
      var original = btn.innerHTML;
      btn.disabled = true;
      if (btn.hasAttribute('data-busy-label')) btn.textContent = btn.getAttribute('data-busy-label');
      Cart.add(variant, 1, props).then(function () {
        if (checkout) { window.location.href = '/checkout'; return; }
        toast(btn.getAttribute('data-toast-title') || 'Added to cart!', btn.getAttribute('data-toast-desc') || '');
      }).catch(function () { toast('Something went wrong. Please try again.'); })
        .finally(function () { btn.disabled = false; btn.innerHTML = original; });
    });
  }

  function init() {
    initConsent();
    initHeader();
    initMenu();
    initReveal();
    initParallax();
    initImageFade();
    initBackToTop();
    initSmoothScroll();
    initAccordions();
    initAffiliate();
    initNewsletter();
    Cart.init();
    initAddButtons();
    document.dispatchEvent(new CustomEvent('ej:ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
